import { useState, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import Button from '@components/Button';
import { Typography } from '@components/Typography';
import Avatar from '@components/Avatar';
import { getInitialsFull } from '@helpers/userName';

const StyledAvatar = styled(Avatar)({
    fontSize: '12px',
    marginRight: '10px',
});

const StyledArrow = styled(ArrowDropDownIcon)({
    height: 32,
    '& path': {
        fill: 'var(--text-primary)',
    },
});

const UnassignedIcon = styled(PersonOutlineRoundedIcon)({
    fontSize: 18,
    color: 'var(--text-tertiary)',
});

const UsersMenu = ({ value, options, onSelect, label }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const selectedOption = useMemo(() => options.find(user => user.value === value), [options, value]);

    const onClick = event => setAnchorEl(event.currentTarget);

    const onClose = () => setAnchorEl(null);

    return (
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginRight: '8px' }}>
            <Button variant="text" onClick={onClick} sx={{ padding: 0, minWidth: '20px', borderRadius: '45px' }}>
                <Avatar
                    size="medium"
                    fullName={selectedOption?.value != null ? selectedOption?.label : undefined}
                    label={selectedOption?.value != null ? getInitialsFull(selectedOption?.label) : undefined}
                    image={selectedOption?.profileImageUrl}
                    icon={<UnassignedIcon />}
                />
            </Button>
            {label && (
                <Typography
                    variant="body2"
                    onClick={onClick}
                    sx={{ marginLeft: '8px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                >
                    {label}
                </Typography>
            )}
            <StyledArrow size="small" onClick={onClick} />
            <Menu
                id="users-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={onClose}
                sx={{
                    '.MuiMenu-paper': {
                        borderRadius: '8px',
                    },
                }}
            >
                {options.map(user => (
                    <MenuItem
                        key={user.value}
                        onClick={() => {
                            onSelect(user.value);
                            onClose();
                        }}
                        selected={user.value === value}
                        sx={{
                            '&.Mui-selected': {
                                backgroundColor: '#E4EAEB !important',
                            },
                        }}
                    >
                        <StyledAvatar
                            size="small"
                            fullName={user.value != null ? user.label : undefined}
                            label={user.value != null ? getInitialsFull(user.label) : undefined}
                            image={user.profileImageUrl}
                            icon={<UnassignedIcon sx={{ fontSize: 16 }} />}
                        />
                        <Typography variant="body2">{user.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default UsersMenu;
